<template>
    <strong>
        <slot />
    </strong>
</template>
